﻿import { Component, Input, HostBinding } from '@angular/core';

@Component({
    selector: 'loading-modal',
    templateUrl: './loading.component.html',
    styleUrls: ['./loading.component.css']
})
export class LoadingComponent {
    @Input() show: boolean = false;
}